/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Col, Collapse, Row } from "react-bootstrap";
import { Divider, Loader, toaster } from "rsuite";
import CardC from "../../../components/CustomCard/CardC";
import InputSearch from "../../../components/inputs/InputSelectSearch";
import { Perfil } from "../../../types/admin-usuarios/Perfil";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Modulo } from "../../../types/admin-usuarios/Modulo";
import TablaModulos from "./TablaModulos";
import createURL from "../../../libs/peticiones/url";
import { PerfilModulo } from "../../../types/admin-usuarios/PerfilModulo";
import { Sistema } from "../../../types/admin-usuarios/Sistema";

export default function PerfilesModulos(){
    const [loading, setLoading] = useState<boolean>(true);
    const [perfiles, setPerfiles] = useState<Perfil[]>([]);
    const [sistemas, setSistemas] = useState<Sistema[]>([]);
    const [modulos, setModulos] = useState<Modulo[]>([]);
    const [filteredModulos, setFilteredModulos] = useState<Modulo[]>([]);
    const [permisosModulos, setPermisosModulos] = useState<PerfilModulo[]>([]);
    const [system, setSystem] = useState<string|undefined>();
    const [selected, setSelected] = useState<string|undefined>();
    const [open, setOpen] = useState<boolean>(false);

    useEffect(()=>{
        getSistemas();
        getModulos();
        getPerfiles();
    }, []);


    async function getSistemas() {
        const res = await peticionBack({}, `/sistemas`, "GET", false, toaster);
        if(res) setSistemas(res.data);
    }

    async function getPerfiles() {
        const res = await peticionBack({}, `/perfiles`, "GET", false, toaster);
        if(res) setPerfiles(res.data);
        setLoading(false);
    }
    
    async function getModulos(){
        const res = await peticionBack({}, "/modulos", "GET", false, toaster);
        if(res){ 
            setModulos(res.data);
        }
    }

    async function getPermissions() {
        if(!selected) return;
        setLoading(true);
        const route = createURL(`/perfiles/get_profiles_modules`, [
            {name: "profile", value: selected as string},
            {name: "populate", value: "module"},
        ]);
        const res = await peticionBack({}, route, "GET", false, toaster);
        if(res){
            const actives = res.data.filter((d: any) => !!d.module );
            setPermisosModulos(actives);
            setFilteredModulos(modulos.filter((m: Modulo)=> m.system === system));
            setOpen(true);
        }
        setLoading(false);
    }

    useEffect(()=>{
        setOpen(false);
    }, [selected, system]);
    return(
        <CardC>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2 ">
                <h4 className="">Perfiles - Módulos</h4>
            </div>

            <Row>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Sistema"
                        name="system"
                        value={system || ""}
                        values={sistemas}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={({target} : any)=> { setSystem(target.value); setSelected(undefined); }}
                    />
                </Col>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Perfil"
                        name="perfil"
                        value={selected || ""}
                        values={perfiles.filter((p: Perfil)=> p.system === system)}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={({target} : any)=> setSelected(target.value)}
                        disabled={!system}
                    />
                </Col>
                <Col xs={12} className="pt-2 d-grid d-md-block text-center">
                    <Button onClick={()=>getPermissions()}>Abrir</Button>
                </Col>
            </Row>

            <Collapse in={open} onExited={()=>{setPermisosModulos([])}}>
                <div>
                    <Divider />
                    <div className="text-end">
                        <Button variant="danger" onClick={()=>setOpen(false)}>Cerrar</Button>
                    </div>
                    <TablaModulos id={selected as string} modulos={filteredModulos} permisos={permisosModulos}/>
                </div>
            </Collapse>

            { loading && <Loader backdrop vertical style={{zIndex: 5}} /> }
        </CardC>
    )
}